import { NavBack } from "@/components/layout/Menu/NavBack";

export function SLA2026_Venue() {
	console.log("SLA2026_Venue")
	return (<div>
		<NavBack />
		<iframe
			src="https://sla.iasma.id/SLA-2026-paparan.pdf"
			className="w-full h-[calc(100vh-65px)] border-none"
			title="External Document"
		/>
	</div>
	);

}